import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "@material-tailwind/react";
import { HashRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HashRouter>
    <ThemeProvider>
      <App />
    </ThemeProvider>
    </HashRouter>
  </React.StrictMode>
);

// Register service worker for PWA offline support
if ("serviceWorker" in navigator) {
  // Register immediately, don't wait for load event (better for iOS)
  const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
  
  navigator.serviceWorker
    .register(swUrl, { scope: "/" })
    .then((registration) => {
      console.log("[Service Worker] Registered successfully:", registration.scope);
      
      // For iOS, ensure service worker is active
      if (registration.installing) {
        console.log("[Service Worker] Installing...");
      } else if (registration.waiting) {
        console.log("[Service Worker] Waiting...");
      } else if (registration.active) {
        console.log("[Service Worker] Active");
      }
      
      // Check for updates every hour
      setInterval(() => {
        registration.update();
      }, 60 * 60 * 1000);
      
      // Handle updates
      registration.addEventListener("updatefound", () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        
        installingWorker.addEventListener("statechange", () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              console.log("[Service Worker] New content available, please refresh");
            } else {
              console.log("[Service Worker] Content cached for offline use");
            }
          }
        });
      });
    })
    .catch((registrationError) => {
      console.log("[Service Worker] Registration failed:", registrationError);
    });
  
  // Handle controller change (service worker update)
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
  
  // For iOS, also wait for load to ensure everything is ready
  window.addEventListener("load", () => {
    if (navigator.serviceWorker.controller) {
      console.log("[Service Worker] Controller is ready");
    } else {
      console.log("[Service Worker] No controller yet");
    }
  });
}
